import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { API, Auth } from "aws-amplify";
import ReactExport from "react-data-export";
import { format } from "date-fns";
import _ from "lodash";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function ReportRelationship({ min, max, selectToday }) {
  const [loading, setLoadingExportContract] = useState(false);
  const [count, setCountContract] = useState(0);
  const [dataReport, setDataReport] = useState([]);
  const [isClick, setIsClick] = useState(false);

  useEffect(() => {
    if (isClick) {
      const getExportId = document.getElementById(
        "export-excel-report-relationship"
      );
      getExportId.click();
    }
  }, [isClick, dataReport]);

  const styleColumnContract = {
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    borders: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
    fill: { fgColor: { rgb: "dbdbdb" } },
  };

  const getLastItem = (lastItem) => {
    let lastItemStr = "";
    if (lastItem) {
      const lastItemKeys = Object.keys(lastItem);
      lastItemKeys.forEach((key) => {
        lastItemStr += `${key}=${lastItem[key]}&`;
      });
    }
    return lastItemStr;
  };

  const onClickExportExcelAllContract = async () => {
    try {
      setLoadingExportContract(true);
      let lastItem = null;
      let datas = {};
      let count = 0;
      let allData = { body: { Items: [] } };
      do {
        datas = await API.get("MoneyHubAdmin", "/loan/reportRelationship", {
          queryStringParameters: {
            min_created: min,
            max_created: max,
            SELECT_ALL: true,
            ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = datas?.body?.lastItem;
        count += datas?.body?.count;
        allData.body.Items = [...allData.body.Items, ...datas.body.Items];
        setCountContract(count);
      } while (lastItem);

      const parseData = allData.body.Items;

      let lastLoanTotal = {
        loan_id: "",
        type: "",
        lastname: "",
        name: "",
        gender: "",
        age: "",
        marritalStatus: "",
        education: "",
        careertype: "",
        income: "",
        burden: "",
        burdenSum: "",
        currentAddress: "",
        interestFuture: "",
        interestReceive: "",
        installments: "",
        loan_status: "",
        requestamount: "",
        capitalRemain: "",
        period: "",
        requestTime: "",
        endDate: "",
        interestMore: "",
      };

      lastLoanTotal.requestamount = parseData?.reduce((prev, loan) => {
        return prev + +loan.requestamount;
      }, 0);

      lastLoanTotal.capitalRemain = parseData?.reduce((prev, loan) => {
        return prev + +loan.capitalRemain;
      }, 0);

      lastLoanTotal.interestFuture = parseData.interestFuture;
      lastLoanTotal.interestReceive = parseData.interestReceive;

      setDataReport([...parseData, lastLoanTotal]);
      setLoadingExportContract(false);
      setIsClick(true);
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const style = {
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    // border: borderColumn,
  };

  const createDataWithStyleContract = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14, name: "Cordia New" },
      border: borders,
      alignment: { vertical: "center", horizontal: "center" },
    };

    for (let i = 0; i < data.length; i++) {
      const currentAddress = _.toString(data[i].currentAddress).replace(
        " ",
        ","
      );
      const splitCurrentAddress = currentAddress?.split(",");

      const addressOri = _.toString(data[i].address).replace(" ", ",");
      const splitAddressOri = addressOri?.split(",");

      let address = {
        distirct: "ว่าง",
        province: "ว่าง",
      };

      if (splitCurrentAddress.length > 1) {
        const currentDistirct = `${splitCurrentAddress[1]}`;
        const currentProvince = `${splitCurrentAddress[2]}`;
        if (currentDistirct) {
          address.distirct = currentDistirct;
        }
        if (currentProvince) {
          address.province = currentProvince;
        }
      } else {
        if (splitAddressOri.length > 2) {
          const currentDistirct = `${splitAddressOri[1]}`;
          const currentProvince = `${splitAddressOri[2]}`;
          if (currentDistirct) {
            address.distirct = currentDistirct;
          }
          if (currentProvince) {
            address.province = currentProvince;
          }
        }
      }

      if (i === data.length - 1) {
        delete style.border;
      }
      result.push([
        {
          value: i === data.length - 1 ? "" : i + 1,
          style,
        },
        {
          value: data[i]?.loan_kbank_id || "",
          style,
        },
        {
          value: data[i]?.type || "",
          style,
        },
        {
          value: data[i]?.name + " " + data[i]?.lastname,
          style,
        },
        {
          value: data[i]?.gender || "",
          style,
        },
        {
          value: data[i]?.age || "",
          style,
        },
        {
          value: data[i]?.marritalStatus || "",
          style,
        },
        {
          value: data[i]?.education || "",
          style,
        },
        {
          value: data[i]?.careertype || "",
          style,
        },
        {
          value: data[i]?.income || "-",
          style,
        },
        {
          value:
            i === data.length - 1
              ? ""
              : `${+Math.ceil(
                  +data[i]?.income - +data[i]?.burden - +data[i]?.burdenSum
                )}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${address?.distirct}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${address?.province}`,
          style,
        },
        {
          value: i === data.length - 1 ? "Total" : `${data[i]?.loan_status}`,
          style,
        },
        {
          value: `${data[i]?.requestamount}`,
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
            },
          },
        },
        {
          value: `${data[i]?.capitalRemain}`,
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
            },
          },
        },
        {
          value: data[i]?.interestFuture || "0",
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
            },
          },
        },
        {
          value: data[i]?.interestReceive || "0",
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
              color: { fgColor: { rgb: "17fbff" } },
            },
          },
        },
        {
          value: data[i]?.period,
          style,
        },
        {
          value:
            i === data.length - 1
              ? ""
              : format(new Date(data[i]?.requestTime), "dd/MM/yyyy"),
          style,
        },
        {
          value:
            i === data.length - 1
              ? ""
              : format(new Date(data[i]?.endDate), "dd/MM/yyyy"),
          style,
        },
        {
          value: data[i]?.interestMore || "0",
          style,
        },
        {
          value: data[i]?.completedAt
            ? format(new Date(data[i].completedAt), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i]?.completedBy || "-",
          style,
        },
        {
          value: data[i]?.approvedAt
            ? format(new Date(data[i].approvedAt), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i]?.approvedBy || "-",
          style,
        },
        {
          value: data[i]?.referalName || "-",
          style,
        },
        {
          value: data[i]?.referalPhone || "-",
          style,
        },
        {
          value: data[i]?.relation || "-",
          style,
        },
        {
          value: data[i]?.referalName2 || "-",
          style,
        },
        {
          value: data[i]?.referalPhone2 || "-",
          style,
        },
        {
          value: data[i]?.relation2 || "-",
          style,
        },
      ]);
    }
    return result;
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "No",
          width: { wch: 10 },
          style: styleColumnContract,
        },
        {
          title: "Contract No",
          width: { wch: 36 },
          style: styleColumnContract,
        },
        {
          title: "Contract Type",
          width: { wch: 12 },
          style: styleColumnContract,
        },
        {
          title: "Customer Name",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "เพศ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "อายุ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "สถานะ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "ระดับการศึกษา",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "อาชีพ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "รายรับ / เดือน",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "รายรับคงเหลือ / เดือน",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ปัจจุบัน (อำเภอ)",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ปัจจุบัน (จังหวัด)",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "Status",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "ยอดสินเชื่อทั้งหมด",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ยอดสินเชื่อคงเหลือ",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ดอกเบี้ยประมาณการ",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ดอกเบี้ยที่ได้รับแล้ว",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "จำนวนงวด",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "วันที่เริ่มต้นสัญญา",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "วันที่สิ้นสุดสัญญา",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ดอกเบี้ยสะสม จากการค้างชำระ",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Complete Date",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Complete By",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Approve Date",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Approved By",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "บุคคลอ้างอิงลำดับที่ 1",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "เบอร์โทรศัพท์บุคคลอ้างอิงลำดับที่ 1",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ความสัมพันธ์บุคคลอ้างอิงลำดับที่ 1",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "บุคคลอ้างอิงลำดับที่ 2",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "เบอร์โทรศัพท์บุคคลอ้างอิงลำดับที่ 2",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ความสัมพันธ์บุคคลอ้างอิงลำดับที่ 2",
          width: { wch: 24 },
          style: styleColumnContract,
        },
      ],
      data: createDataWithStyleContract(dataReport),
    },
  ];

  return (
    <div>
      <ExcelFile
        filename={`REPORT_RELATION_SHIP_${format(
          new Date(selectToday),
          "yyyy-MM-dd"
        )}`}
        element={<button id="export-excel-report-relationship" hidden></button>}
      >
        <ExcelSheet
          dataSet={multiDataSet}
          name="Report Relation Ship"
        ></ExcelSheet>
      </ExcelFile>
      <button
        disabled={loading}
        className={classNames(
          "p-4  text-white mt-2 flex flex-row rounded-lg items-center w-full",
          {
            "bg-green-500": !loading,
            "bg-gray-400": loading,
          }
        )}
        onClick={onClickExportExcelAllContract}
      >
        {loading && (
          <svg
            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx={12}
              cy={12}
              r={10}
              stroke="currentColor"
              strokeWidth={4}
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        )}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
          />
        </svg>
        {count > 0 && `(${count})`} Relationship Report
      </button>
    </div>
  );
}

export default ReportRelationship;
